import { render, staticRenderFns } from "./SupplierUsers.vue?vue&type=template&id=11df200b&scoped=true&"
import script from "./SupplierUsers.vue?vue&type=script&lang=js&"
export * from "./SupplierUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11df200b",
  null
  
)

export default component.exports